import React from 'react';
import PropTypes from 'prop-types';

import {dispatch, connect} from 'utils/state_manager';

import {Box, Stack, Typography} from 'views/components';
import {Translate} from 'views/module';

import ActionLog from './case_scenes/ActionLog';
import ActionLogTextbox from './case_scenes/ActionLogTextbox';
import CaseDomainGuide from './case_scenes/CaseDomainGuide';
import CaseTitle from './case_scenes/CaseTitle';

import backend from 'utils/backend';

const CaseView = (props) => {
  const {
    caseRn,
    statusProgressWrap: progressWrap,
    userRn,
  } = props;
  const [caseData, setCaseData] = React.useState(null);
  const [caseDataLoaded, setCaseDataLoaded] = React.useState(false);

  React.useEffect(() => {
    let isActive = true;

    const loadCase = async () => {
      await progressWrap(async () => {
        const caseResponse = await backend.case.getCase(caseRn);

        if (isActive) {
          setCaseData(caseResponse || null);
          setCaseDataLoaded(true);
        }
      });
    };

    loadCase();

    return () => {
      isActive = false;
    };
  }, [caseRn, progressWrap]);

  if (!caseDataLoaded) {
    return null;
  }

  if (!caseData) {
    return (
      <Box
        sx={{
          textAlign: 'left',
          width: {
            xs: '100%',
            md: '75%',
          },
        }}
      >
        <Typography
          sx={{
            fontSize: '18px',
            fontWeight: 500,
            color: '#1A1916',
          }}
        >
          <Translate expression='case.Detail.NotFound' />
        </Typography>
      </Box>
    );
  }

  const updateStatus = (status) => {
    if (!caseData.caseRn || status === caseData.status) {
      return;
    }

    progressWrap(async () => {
      const statusResponse = await backend.case.updateStatus(caseData.caseRn, status);

      setCaseData((prevCaseData) => ({
        ...prevCaseData,
        status: statusResponse.status,
      }));
    });
  };

  const createActionLog = async (actionLogMessage) => {
    let actionLogCreated = false;
    const message = `Inbound admin chat message: ${userRn}: ${actionLogMessage}`;

    await progressWrap(async () => {
      const actionLogResponse = await backend.case.createActionLog(caseData.caseRn, message);

      setCaseData((prevCaseData) => ({
        ...prevCaseData,
        actionLog: [
          ...(prevCaseData.actionLog || []),
          {
            message: actionLogResponse.message,
            createdAt: new Date().toISOString(),
          },
        ],
      }));
      actionLogCreated = true;
    }, {
      showProgress: false,
    });

    return actionLogCreated;
  };

  return (
    <Box
      sx={{
        textAlign: 'left',
        width: {
          xs: '100%',
          md: '75%',
        },
      }}
    >
      <Stack gap={3}>
        <CaseTitle caseData={caseData} updateStatus={updateStatus} />
        <CaseDomainGuide domainGuide={caseData.domainGuide} />
        <Stack gap={1.5}>
          <ActionLog actionLog={caseData.actionLog || []} />
          <ActionLogTextbox onSubmit={createActionLog} />
        </Stack>
      </Stack>
    </Box>
  );
};

CaseView.propTypes = {
  caseRn: PropTypes.string.isRequired,
  statusProgressWrap: PropTypes.func.isRequired,
  userRn: PropTypes.string.isRequired,
};

const mapStateToProps = (state) => ({
  userRn: state.user.userRn,
});

export default connect(mapStateToProps, dispatch)(React.memo(CaseView));
